import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import GenericFlowExport from "./export-tables/generic-flow-export.jsx";
import DayHourExport from "./export-tables/day-hour-export.jsx";
import TableBody from "./table-body.jsx";

const DayDataset = ({ data }) => {
    const passagesByDayDatasets = data?.passagesByDayDatasets || [];

    useEffect(() => {
        passagesByDayDatasets.forEach((dayDataset) => {
            const dayMap = new Map();
            const globalDaysMap = new Map();
            dayDataset.data.forEach(item => {
                dayMap.set(item.day, (dayMap.get(item.day) || 0) + parseInt(item.qty, 10));
                globalDaysMap.set(item.day, true);
            });
            let labels = [], values = []

            const entries = Array.from(dayMap.entries())
                .sort(([a], [b]) => a.localeCompare(b));

            labels = entries.map(e => e[0]);
            values = entries.map(e => e[1]);

            const dataColumns = passagesByDayDatasets.map(dataset => {
                const datasetVal = new Map();
                dataset.data.forEach(item => {
                    datasetVal.set(item.day, parseInt(item.qty, 10));
                });

                const orderedVals = labels.map(dia => datasetVal.get(dia) || 0);

                return [dataset.title, ...orderedVals];
            })
            GraphicUtils.lineChart(`traffic-flow-day`, dataColumns, labels, "Intervalo de dias", "Quantidade de passagens");
            ReportUtils.createExportableTable(null, null, `Data e hora de maior fluxo`, "day-hour-export");
            if (values.some(v => v > 0)) ReportUtils.createExportableTable(null, null, `Fluxo veicular por dia`, "day-export");
        });
    }, [data])

    return (
        <>
            <div className={"print:break-before-page"}>
                {data.passagesDatasets.map((day, index) => {
                    const datasets = day.data ?? [];
                    let title = day.title;
                    let total = 0;
                    let date  = 0;

                    datasets.forEach(value => {
                        total = total > value.total ? total : value.total;
                        date = total === value.total ? value.dh : date;
                    });

                    return (
                        <React.Fragment key={index}>
                            <div className={`flex flex-row flex-nowrap justify-center gap-8 w-full mb-2 ${index === 0 ? 'items-end' : 'items-center'}`}>
                                <div className={`w-[35%] text-center text-[16px] break-words font-bold ${index === 0 ? 'mb-[6px]' : ''}`}>
                                    {title}
                                </div>

                                <div className="w-[25%] text-center shrink-0">
                                    {index === 0 && (
                                        <div className="text-[15px] font-bold mb-2">Data/hora de maior fluxo</div>
                                    )}
                                    <div className="border border-gray-300 rounded py-1 px-4 text-[20px] font-bold bg-white text-black">
                                        {date}
                                    </div>
                                </div>

                                <div className="w-[25%] text-center shrink-0">
                                    {index === 0 && (
                                        <div className="text-[15px] font-bold mb-2">Passagens</div>
                                    )}
                                    <div className="border border-gray-300 rounded py-1 px-4 text-[20px] font-bold bg-white text-black">
                                        {total}
                                    </div>
                                </div>
                            </div>

                            <div className="sub-chart-divisor"></div>
                        </React.Fragment>
                    );
                })}

                <TableBody title={"Fluxo veicular por dia"} id={"traffic-flow-day"}/>
            </div>

            <GenericFlowExport datasets={passagesByDayDatasets} flow={"Passagens"} sheetName={"day-export"}/>
            <DayHourExport datasets={data.passagesDatasets}/>
        </>
    );
};

export default DayDataset;